import CertsListSidePanel from './CertsListSidePanel';

export default CertsListSidePanel;
